import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DconfigCoreSettings } from '../dconfig-core.settings';
import { Observable } from 'rxjs';

const ioServiceUrlBase = DconfigCoreSettings.API_ENDPOINT + '/DConfig/IOServicesAPI';

@Injectable({
  providedIn: 'root'
})
export class IoService {

  constructor(private http: HttpClient) { }

  uploadFile = function (file, path?): Observable<Object> {
    return this.http.post(ioServiceUrlBase + '/createFile' +  (path? '?Path=' + path + '&DconfigReq=false': '') + '?DconfigReq=false', file);
  }

}

